import { Pipe, PipeTransform } from '@angular/core';
import { IhmWarningMessageLevel } from '../../../components/ihm-warning-message/ihm-warning-message.enum';

@Pipe({ name: 'ihmWarningIcon' })
export class IhmWarningIconPipe implements PipeTransform {
  transform(warningLevel: IhmWarningMessageLevel): string {
    if (IhmWarningMessageLevel.ERROR === warningLevel) {
      return 'warning';
    }
    return warningLevel.toLowerCase();
  }
}
